<template>
    <van-popup
        v-if="customerAllocationPopupShow"
        :value="customerAllocationPopupShow"
        z-index="100"
        :close-on-click-overlay="false"
        :style="{ height: '100vh', width: '100vw', background: 'rgba(0,0,0,.3)' }"
        overlay-class="custom_popup"
        position="right"
    >
        <div class="public_container customer_allocation_wrap" v-loading="loading">
            <div class="returnNavBar">
                <ReturnNavBar
                    :isCustomReturnEvent="true"
                    :isTitleNormal="true"
                    :isAllFunctions="true"
                    title="返回"
                    @returnEvent="handleClickClose"
                ></ReturnNavBar>
            </div>
            <div class="mobile_container">
                <van-form
                    label-width="9.5em"
                    input-align="right"
                    scroll-to-error
                    :show-error-message="false"
                    ref="customerForm"
                    class=""
                >
                    <van-field
                        required
                        v-model="formData.allocator_name"
                        name="分配至"
                        label="分配至"
                        placeholder="请选择"
                        is-link
                        readonly
                        @click="handleClickSelectUser"
                        :rules="[{ required: true, message: '请选择' }]"
                    >
                    </van-field>
                </van-form>
                <div class="operate_customer_list_box">
                    <div class="operate_customer_list_box_title">您将要分配以下客户</div>
                    <ul class="operate_customer_list">
                        <li v-for="item in companyList" :key="item.id">
                            <p class="ellipsis">{{ item.name && item.name.value }}</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="add_footer_wrap">
                <van-button round block type="info" @click="handleClickConfirm">确定</van-button>
            </div>
            <UserSearchSelect
                :userSelectVisible.sync="userSelectVisible"
                :userSelectTitle="'分配至'"
                :extraSearchForm="{ type: 'customer_seas', sea_id: sea_id }"
                @selectUserData="handleSelectUserData"
                v-if="userSelectVisible"
            />
        </div>
    </van-popup>
</template>

<script>
import { CustomerPublicAllocate } from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import UserSearchSelect from "@/components/mComponents/UserSearchSelect.vue";
export default {
    name: "CustomerAllocation",
    components: { ReturnNavBar, UserSearchSelect },
    props: {
        customerAllocationPopupShow: {
            type: Boolean,
            default: false,
        },
        sea_id: "",
        companyList: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            loading: false,
            formData: {
                allocator_uid: "",
                allocator_name: "",
            },
            userSelectVisible: false,
        };
    },
    created() {},
    methods: {
        handleClickClose() {
            this.$emit("update:customerAllocationPopupShow", false);
        },
        handleClickSelectUser() {
            this.userSelectVisible = true;
        },
        handleSelectUserData(data) {
            console.log(data);
            this.formData.allocator_uid = data.uid;
            this.formData.allocator_name = data.name;
        },
        handleClickConfirm() {
            this.$refs.customerForm.validate().then(() => {
                this.loading = true;
                const params = {
                    allocator_uid: this.formData.allocator_uid,
                    customer_ids: this.companyList.map((item) => item.id),
                };
                CustomerPublicAllocate(params)
                    .then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.$emit("update:customerAllocationPopupShow", false);
                                    this.$emit("allocationSuccess");
                                },
                            });
                        } else {
                            this.$toast({
                                message: res.message,
                                type: "fail",
                            });
                        }
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/m_style/customers.scss";
.customer_allocation_wrap {
    .mobile_container {
        padding: 10px 16px;
    }
}
</style>
